const GRAY_SHIPPING_ZONE = [
  'CA', 'NV', 'OR', 'WA', 'AZ', 'CO', 'UT', 'ID', 'WY', 'MT', 'ND', 'SD', 'MN', 'HI', 'AK',
]

const WHITE_SHIPPING_ZONE = [
  'NM', 'TX', 'OK', 'KS', 'NE', 'IA', 'MO', 'AR', 'LA', 'MS', 'TN', 'KY', 'IL', 'WI', 'MI', 'IN', 'OH', 'WV', 'AL', 'FL', 'GA', 'SC', 'NC', 'VA', 'MD', 'DE', 'NJ', 'PA', 'NY', 'CT', 'RI', 'MA', 'NH', 'VT', 'ME', 'HI', 'AK',
]

export const FORTY_EIGHT_STATES = [
  'CA', 'NV', 'OR', 'WA', 'AZ', 'CO', 'UT', 'ID', 'WY', 'MT', 'ND', 'SD', 'MN', 'NM', 'TX', 'OK', 'KS', 'NE', 'IA', 'MO', 'AR', 'LA', 'MS', 'TN', 'KY', 'IL', 'WI', 'MI', 'IN', 'OH', 'WV', 'AL', 'FL', 'GA', 'SC', 'NC', 'VA', 'MD', 'DE', 'NJ', 'PA', 'NY', 'CT', 'RI', 'MA', 'NH', 'VT', 'ME',
]

export const AU_STATES = [
  'NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'NT', 'ACT',
]

// eslint-disable-next-line no-shadow
export enum ShippingZone {
  GRAY = 'Gray Zone', WHITE = 'White Zone'
}

export const ShippingZones: {[key: string]: string[]} = {
  [ShippingZone.GRAY]  : GRAY_SHIPPING_ZONE,
  [ShippingZone.WHITE] : WHITE_SHIPPING_ZONE,
}
export const getShippingZone = (region: string): ShippingZone | undefined => {
  let correctShippingZone
  Object.keys(ShippingZones).forEach((zoneKey) => {
    const zone = ShippingZones[zoneKey]
    if (zone.includes(region)) {
      correctShippingZone = zoneKey
    }
  })

  return correctShippingZone
}
